import React from "react";

function IconPhone(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 31.685 31.685"
      version="1.1"
      viewBox="0 0 31.685 31.685"
      xmlSpace="preserve"
      width={props.width}
      height={props.height}
      fill={props.fill}
    >
      <path d="M22.507 0H9.175A2.306 2.306 0 006.87 2.309v27.07a2.306 2.306 0 002.305 2.306h13.332a2.308 2.308 0 002.307-2.306V2.309A2.31 2.31 0 0022.507 0zm.578 25.672H8.599V3.895h14.486v21.777zM18.932 2.343h-6.181v-.674h6.182l-.001.674zm2.645-.308a.591.591 0 01-1.182 0 .591.591 0 011.182 0zm-2.922 27.19h-5.629v-1.732h5.629v1.732z"></path>
    </svg>
  );
}

export default IconPhone;
